module.exports = __webpack_public_path__ + "static/media/software.a1843fef.jpg";